<template>
    <section class="banner-orientacoes txt-white p-3">
        <div class="row">
            <div class="col-12 col-lg-3 text-left">
                <span class="txt-h-6 txt-w-4 txt-white txt-letter-n-2">
                    Tem dúvidas em relação
                    a qualquer assunto?
                </span>
                <p class="mt-3 mb-0 txt-h-5 txt-w-4 txt-white txt-letter-n-2" style="line-height: 25px;">
                    Conheça o <span class="txt-w-8">Sollicita Orientações</span>,
                    nossa plataforma especializada em
                    orientações técnicas
                </p>
            </div>
            <div class="col-12 col-lg-6 d-flex align-items-center justify-content-center my-2 my-md-0">
                <img :src="logo" class="img-responsive logo-orientacoes" />
            </div>
            <div class="col-12 col-lg-3">
                <span class="txt-h-5 txt-white txt-letter-n-2" style="line-height: 31px;">
                    Venha conferir o sistema
                    de orientações mais completo
                    que existe!
                </span>
                <a class="btn link-btn txt-h-4 mt-3 w-100" :href="urlOrientacoes" target="_blank"> Ir para a página </a>
            </div>
        </div>
    </section>
</template>

<script>
    import { urlOrientacoes } from '@/config/global'
    import logo from '@/assets/img/logo-orientacoes.png';

    export default {
        components: {
        },
        data() {
            return {
                urlOrientacoes: urlOrientacoes,
                logo: logo,
            }
        },
        methods: {
            irParaPagina() {
                window.open(this.urlSollicita, '_blank');
            }
        },
        mounted() {            
        }
    }


</script>


<style lang="scss">
    .banner-orientacoes {
        background: url(~@/assets/img/fundo-banner-orientacoes.png) no-repeat top center;
        border-radius: 5px;
        font-family: Roboto;
        font-size: 16px;
        background-size: 100%;
        background-size: cover;
    }

    .banner-orientacoes .link-btn {
        display: block;
        background: #78279D;
        border: 2px solid #78279D;
        border-radius: 5px;
        padding: 10px 50px;
        color: #fff;
        float: right;
    }

    .logo-orientacoes{
        width: 300px;
    }

</style>